import { useRef, useState } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import InputWithLabel from "../inputs/InputWithLabel";
import TextareaWithLabel from "../inputs/TextareaWithLabel";
import DateInputWithLabel from "../inputs/DateInputWithLabel";
import { Button } from "../ui/button.tsx";
import { Input } from "../ui/input.tsx";
import { Badge } from "../ui/badge.tsx";
import { Plus, X } from "lucide-react";
import { PostBodyFormType } from "./types";
import { Form } from "@/shared/ui/form.tsx";
import { Catalog } from "./api/single-post-api";

type Props = {
  postForm: UseFormReturn<PostBodyFormType>,
  catalog: Catalog[],
}

const PostBodyForm = ({ postForm }: Props) => {

  const [showTagInput, setShowTagInput] = useState(false)
  const tagInputRef = useRef<HTMLInputElement | null>(null)

  const watchedTags = useWatch({
    control: postForm.control,
    name: "hashtags",
  });

  return (
    <Form {...postForm}>
      <form className="flex flex-col gap-4">
        <TextareaWithLabel<PostBodyFormType> fieldTitle="Content" nameInSchema="post_content" rows={8} />
        <div className="flex items-center flex-col lg:flex-row gap-3 w-full">
          <DateInputWithLabel<PostBodyFormType> fieldTitle="Posting Date" nameInSchema="post_date" containerClass="flex-1 w-full" />
          <InputWithLabel<PostBodyFormType> type="time" fieldTitle="Posting Time" nameInSchema="post_time" containerClass="flex-1 w-full" />
        </div>
        <p className="font-medium text-sm font-poppins">Tags</p>
        <div className="flex flex-wrap items-center gap-2 justify-start">
          {watchedTags.map((tag, index) => (
            <Badge
              className="px-4 py-1 tracking-wide cursor-pointer bg-slate-200 text-black hover:bg-slate-200 font-poppins font-light"
              key={index}
              onClick={() => {
                const updatedTags = watchedTags.filter((_, i) => i !== index);
                postForm.setValue("hashtags", updatedTags);
              }}
            >
              {tag}
            </Badge>
          ))}
        </div>
        {showTagInput && (
          <Input
            ref={tagInputRef}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                if (tagInputRef && tagInputRef.current) {
                  const value = `#${tagInputRef.current.value}`;
                  if (value) {
                    postForm.setValue("hashtags", [...postForm.getValues("hashtags"), value]);
                    tagInputRef.current.value = "";
                  }
                }
              }
            }}
          />
        )}
        <Button type="button" className="px-4 py-1 my-2 tracking-wide bg-slate-200 h-7 cursor-pointer text-black hover:bg-slate-200" onClick={() => {
          setShowTagInput(prev => !prev)
          if (tagInputRef && tagInputRef.current) {
            tagInputRef.current.focus()
          }
        }}>{showTagInput ? <X /> : <Plus /> }</Button>
      </form>
    </Form>
  )
}

export default PostBodyForm;
